var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ButtonsIcon',{attrs:{"icon":"mdi-plus","color":_vm.color},on:{"clicked":function($event){return _setup.emit('clicked', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }